import React from 'react';

import { CONSTANTS } from '../../../../../core/config/constants';
import { ColumnPresetContextProvider } from '../../../../FinancialData/shared/ColumnPresetContext/ColumnPresetContext';
import { FilterContextProvider } from '../../../../FinancialData/shared/FinancialDataContext/FinancialDataContext';
import Refinement from './Refinement';

const RefinementWrapper: React.FC = () => {
  return (
    <FilterContextProvider
      version={CONSTANTS.REFINEMENT_COMPANIES_FILTER_STORAGE.VERSION}
      storageKey={CONSTANTS.REFINEMENT_COMPANIES_FILTER_STORAGE.KEY}
    >
      <ColumnPresetContextProvider>
        <Refinement />
      </ColumnPresetContextProvider>
    </FilterContextProvider>
  );
};

export default RefinementWrapper;
